/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".rfc-management-dialog h2{margin:0!important;padding:0!important}.rfc-management-dialog-header{height:76px}.rfc-management-dialog-content{width:640px}.rfc-management-dialog-content-left,.rfc-management-dialog-content-right{height:100%}.rfc-management-dialog-content .info{margin:1rem 0 .5rem}.rfc-management-dialog-content .info~hr{margin-bottom:1rem}.rfc-management-dialog-content .info mat-chip{margin-right:1rem}.rfc-management-dialog-seperator{background-color:rgba(0,0,0,.12);height:100%;margin:0 16px;width:1px}.rfc-management-dialog-actionbar{justify-content:flex-end}"];
export { styles as styles };

